import * as React from 'react';
import QRCodeTile from '../components/QRCodeTile';
import styled from '../theme';
import Title from '../components/TitleComponent';
import SubText from '../components/SubTextComponent';
import LogoComponent from '../components/LogoComponent';
import { ITrackingData } from '../App'
import { trackEvent } from '../analytics/Analytics'

interface IThankYouProps {
    url: string
    locale: string
    content: any
    logo: any
    timeout: number
    hideQRCode?: boolean
    trackingData?: ITrackingData
    changeLocale(e: any): void
    returnToRegistrationPage(): any
}

class ThankYouPage extends React.PureComponent<IThankYouProps> {
    constructor(props: any) {
        super(props);
    }

    public componentDidMount() {
        this.timeoutRedirect(this.props.timeout)

        // Trigger google tag manager successful sign up event.
        trackEvent({event: 'concierge.signup.completed'})
    }

    public renderSubHeading() {
        const textElements: any = [];
        const textContent = this.props.content.subHeading.split('-');

        textContent.map((section: any, index: number) => {
            textElements.push(<SubText content={section} key={index} />)
        })
        return (
            <React.Fragment>
                {textElements}
            </React.Fragment>
        )
    }

    public renderTrackingData(trackingData: ITrackingData) {
        const nodes = []
        if (trackingData.country) {
            nodes.push(<div hidden={true} id={'country'}>{trackingData.country}</div>)
        }

        if (trackingData.city) {
            nodes.push(<div hidden={true} id={'city'}>{trackingData.city}</div>)
        }

        if (trackingData.postcode) {
            nodes.push(<div hidden={true} id={'postcode'}>{trackingData.postcode}</div>)
        }

        return (
          <>{nodes}</>
        )
    }

    public render() {

        if (this.props.content === null) {
            return null
        }

        return (
            <MainWrapper>
                <LogoComponent logo={this.props.logo} />
                <Wrapper>
                    <Title content={this.props.content.title} />
                    {!this.props.hideQRCode && this.renderSubHeading()}

                    { !this.props.hideQRCode && <QRCodeTile value={this.props.url} /> }
                    { !this.props.hideQRCode && <SubText content={this.props.content.qrCodeMessage} /> }
                    { this.props.hideQRCode && <SubText content={this.props.content.tourist_thankyou_message} />}
                    { !this.props.hideQRCode &&
                        <DoneButton onClick={this.props.returnToRegistrationPage}>{this.props.content.buttonLabel}</DoneButton>
                    }

                    {
                        // tslint:disable-next-line:jsx-no-lambda
                        this.props.hideQRCode && <DoneButton onClick={() => window.open(this.props.url)}>View Offers</DoneButton>
                    }
                    {this.props.trackingData && this.renderTrackingData(this.props.trackingData)}
                </Wrapper>
            </MainWrapper>
        )
    }

    private timeoutRedirect(timeout: number): void {
        window.setTimeout(() => {
            this.props.returnToRegistrationPage()
        }, timeout)
    }
}

export default ThankYouPage

const Wrapper = styled.div`
    width: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    padding-top: 30px;
    
    @media (max-width: 550px) {
        width: 100%;
    }
`

const DoneButton = styled.button`
    width: 60%;
    height: 60px;
    background: ${(props: any) => props.theme.colors.backgroundHighlight};
    color: ${(props: any) => props.theme.colors.bodyHighlight};
    border: none;
    border-radius: 5px;
    margin-top: 60px;
    font-weight: 800;

    @media (max-width: 550px) {
        width: 100%;
    }
`
const MainWrapper = styled.div`
    width: 100%;
    min-height: 100%;
    padding: 40px;
    box-sizing: border-box;
    background: -webkit-linear-gradient(${(props: any) => props.theme.colors.backgroundDark2}, ${(props: any) => props.theme.colors.backgroundDark3});
    background: linear-gradient(${(props: any) => props.theme.colors.backgroundDark2}, ${(props: any) => props.theme.colors.backgroundDark3});
    color: ${(props: any) => props.theme.colors.bodyHighlight};
`



// WEBPACK FOOTER //
// ./src/pages/ThankYouPage.tsx